import { render, staticRenderFns } from "./Remarks.vue?vue&type=template&id=5247b5a7&"
import script from "./Remarks.vue?vue&type=script&lang=js&"
export * from "./Remarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5247b5a7')) {
      api.createRecord('5247b5a7', component.options)
    } else {
      api.reload('5247b5a7', component.options)
    }
    module.hot.accept("./Remarks.vue?vue&type=template&id=5247b5a7&", function () {
      api.rerender('5247b5a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/form/textarea/Remarks.vue"
export default component.exports